import React from 'react';

export const ReportingIcon = ({ fill, width=25, height=26, className }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_54_127)">
                <mask id="mask0_54_127" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="67" height="67">
                    <path d="M66.27 0H0V66.27H66.27V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_54_127)">
                    <path opacity="0.4" d="M8.28418 60.7474H57.9866" stroke="white" strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M15.4634 23.1416H11.0454C9.52674 23.1416 8.28418 24.3842 8.28418 25.9028V49.7049C8.28418 51.2236 9.52674 52.4662 11.0454 52.4662H15.4634C16.9821 52.4662 18.2246 51.2236 18.2246 49.7049V25.9028C18.2246 24.3842 16.9821 23.1416 15.4634 23.1416Z" fill="none" stroke="white" strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M35.3443 14.3293H30.9263C29.4076 14.3293 28.165 15.5719 28.165 17.0906V49.7011C28.165 51.2198 29.4076 52.4623 30.9263 52.4623H35.3443C36.863 52.4623 38.1055 51.2198 38.1055 49.7011V17.0906C38.1055 15.5719 36.863 14.3293 35.3443 14.3293Z" fill="none" stroke="white" strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M55.2251 5.52246H50.8071C49.2885 5.52246 48.0459 6.76502 48.0459 8.28371V49.7024C48.0459 51.2211 49.2885 52.4637 50.8071 52.4637H55.2251C56.7438 52.4637 57.9864 51.2211 57.9864 49.7024V8.28371C57.9864 6.76502 56.7438 5.52246 55.2251 5.52246Z" fill="#FFFFFF38" stroke="white" strokeWidth="3.64" strokeLinecap="round" strokeLinejoin="round" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_54_127">
                    <rect width="66.27" height="66.27" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};
